import { render, staticRenderFns } from "./RoutineFooter.vue?vue&type=template&id=2e836728&scoped=true"
import script from "./RoutineFooter.vue?vue&type=script&lang=js"
export * from "./RoutineFooter.vue?vue&type=script&lang=js"
import style0 from "./RoutineFooter.vue?vue&type=style&index=0&id=2e836728&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e836728",
  null
  
)

export default component.exports